import React from 'react'
import { Popover } from '@manychat/manyui'

import { Field } from 'common/fields/entities/field'
import FilterFieldsSearch from 'common/filter/components/FilterFieldsSearch'
import { ConditionField } from 'common/filter/interfaces'

interface FieldPopoverProps {
  anchor: Nullable<HTMLElement>
  fields: Field[]
  isOpen: boolean
  isBuilder: boolean
  onRequestClose: () => void
  onSelect: (field: ConditionField) => void
}

export const FieldPopover = ({
  isOpen,
  anchor,
  onRequestClose,
  onSelect,
  fields,
  isBuilder,
}: FieldPopoverProps) => {
  return (
    <Popover
      key="condition-field-popover"
      open={isOpen}
      anchor={anchor}
      anchorOrigin="left top"
      targetOrigin="left top"
      onRequestClose={onRequestClose}
    >
      <FilterFieldsSearch onSelect={onSelect} fields={fields} isBuilder={isBuilder} />
    </Popover>
  )
}
